import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../store/store";
import GreenTickModal from "../../assets/images/green-tick-for-modal.svg";
import "../../css/testCenter.css";
import { isEmpty } from "lodash";
import {
  useGetTestQuestionsPriorityMutation,
  useSubmitTestMutation,
} from "../../store/testCenterSlice";
import { Button, Modal } from "antd";
import { TestQuestionType } from "../../interfaces/testCenter";
import Countdown from "react-countdown";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { COLOR_CONSTANTS } from "../../constants/stringConstants";
import useWebcam from "../../hooks/functions/useWebcamHook";
import Webcam from "react-webcam";
import { useUploadImageMutation } from "../../store/appSlice";
import CameraPermissionDescription from "./CameraPermissionDescription";

const videoConstraints: MediaTrackConstraints = {
  width: 200,
  height: 200,
  facingMode: "user",
};
function TestQuestions() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { user } = useAppSelector((state) => state["user"]);
  const [testQuestions, setTestQuestions] = useState<Array<TestQuestionType>>([]);
  const [testQuestionIndex, setTestQuestionIndex] = useState<number>(0);
  const [attemptData, setAttemptData] = useState<Array<any>>([]);
  const [selectedQuestionOption, setSelectQuestionOption] = useState<string>("");
  const [isTestCompletedModal, setTestCompletedModal] = useState<boolean>(false);

  const [isTestErrorModal, setTestErrorModal] = useState<boolean>(false);
  const [isLoader, setLoader] = useState<boolean>(false);
  const [camPicURL, setCamPicURL] = useState<string>("");

  const [getTestQuestionsPriority] = useGetTestQuestionsPriorityMutation();
  const [submitTest] = useSubmitTestMutation();

  const { webcamRef, camPic, capture, cameraPermission, setCameraPermission, closeCamera } =
    useWebcam();
  const [uploadImage] = useUploadImageMutation();

  const [testId, setTestId] = useState(localStorage.getItem("testId"));
  const [responseId, setResponseId] = useState(localStorage.getItem("responseId"));
  const [candidateId, setCandidateId] = useState(localStorage.getItem("candidateId"));
  const [testSkill, setTestSkill] = useState(localStorage.getItem("testSkill"));

  useEffect(() => {
    console.log({ localStorage });
    // Check if there is stored state in localStorage

    // const storedState = localStorage.getItem("testState");
    // if (storedState) {
    //   const parsedState = JSON.parse(storedState);
    //   console.log({ parsedState });
    //   setTestId(parsedState.testId);
    //   setResponseId(parsedState.responseId);
    //   setCandidateId(parsedState.candidateId);
    //   setTestSkill(parsedState.testSkill);
    //   // Clear the stored state after retrieving it
    //   localStorage.removeItem("testState");
    // } else {
    //   // Fetch the state from the navigation props
    //   setTestId(localStorage.getItem("testId"));
    //   setResponseId(localStorage.getItem("responseId"));
    //   setCandidateId(localStorage.getItem("candidateId"));
    //   setTestSkill(localStorage.getItem("testSkill"));
    // }

    getPriorityQuestions();
  }, []);

  useEffect(() => {
    // Store the state in localStorage when it changes
    const stateToStore = {
      testId,
      responseId,
      candidateId,
      testSkill,
    };
    localStorage.setItem("testState", JSON.stringify(stateToStore));
  }, [testId, responseId, candidateId, testSkill]);

  useEffect(() => {
    console.log({ camPic });

    if (!isEmpty(camPic)) {
      console.log({ camPic });

      const byteString = window.atob(camPic.split(",")[1]);
      const mimeString = camPic.split(",")[0].split(":")[1].split(";")[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([ab], { type: mimeString });

      let fileData = new File([blob], "abc", { type: mimeString });
      console.log({ fileData });
      const formData = new FormData();
      formData.append("file", fileData);

      uploadImage(formData)
        .unwrap()
        .then((data) => {
          console.log({ data });
          setCamPicURL(data?.url);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [camPic]);

  useEffect(() => {
    if (!isEmpty(camPicURL)) {
      onPressBtn(
        testQuestions[testQuestionIndex].question,
        testQuestions[testQuestionIndex].options,
        selectedQuestionOption
      );
    }
  }, [camPicURL]);

  const getPriorityQuestions = () => {
    const payload = {
      id: testId,
    };
    getTestQuestionsPriority(payload)
      .unwrap()
      .then((questions: any) => {
        console.log({ questions });
        setTestQuestions(questions);
      });
  };

  const onPressBtn = (question: string, options: Array<string>, answer: string) => {
    if (testQuestionIndex >= testQuestions.length - 1) {
      let tempAttemptData = [...attemptData];
      tempAttemptData.push({
        question,
        answer,
        options,
        image: camPicURL,
      });
      setLoader(true);
      const payload = {
        id: responseId,
        data: {
          attemptArray: tempAttemptData,
          isAttempted: true,
        },
      };
      submitTest(payload)
        .unwrap()
        .then((questionsArray: any) => {
          setLoader(false);

          setTestCompletedModal(true);
        });
      {
      }
      return;
    }

    if (isEmpty(selectedQuestionOption)) {
      alert("Please select an option");
      return;
    }

    setSelectQuestionOption("");
    setTestQuestionIndex((testQuestionIndex) => testQuestionIndex + 1);

    let tempAttemptData = [...attemptData];

    tempAttemptData.push({
      question,
      answer,
      options,
      image: camPicURL,
    });
    setAttemptData(tempAttemptData);
  };

  const renderer = (data: any) => {
    // Render a countdown
    console.log({ timeData: data });
    return (
      <div className="countdown_render_container">
        <text>
          {data?.formatted?.minutes}:{data?.formatted?.seconds}
        </text>
      </div>
    );
  };

  const countDownSec = useMemo(
    () => (
      <Countdown
        date={Date.now() + 25 * 60000}
        renderer={renderer}
        onComplete={() => setTestErrorModal(true)}
      />
    ),
    []
  );

  const questionSec = useMemo(() => {
    if (!isEmpty(testQuestions)) {
      return (
        <div className="test_questions_card_container">
          <div className="question_and_countdown_wrapper">
            <text>Q{testQuestionIndex + 1}</text>
          </div>
          <div style={{ marginBottom: "20px" }}>
            <text>{testQuestions[testQuestionIndex].question}</text>
          </div>
          <div style={{ marginBottom: "10px" }}>
            <text style={{ color: "lightslategray", fontWeight: 600 }}>
              Please select your answer
            </text>
          </div>
          <div style={{ width: "100%" }}>
            {testQuestions[testQuestionIndex].options.map((item: string) => {
              const isActive = item === selectedQuestionOption;
              return (
                <div
                  className={`${
                    isActive ? "test_questions_options_style_active" : ""
                  } test_questions_options_style`}
                  onClick={() => setSelectQuestionOption(item)}
                >
                  <text>{item}</text>
                </div>
              );
            })}
          </div>
        </div>
      );
    }
  }, [testQuestions, selectedQuestionOption, testQuestionIndex]);

  const testCompleteModal = () => (
    <Modal
      footer={null}
      visible={true}
      className="ant-modal"
      onCancel={() => {
        setTestCompletedModal(!isTestCompletedModal);
        window.close();
        navigate("/testCenter", { replace: true });
      }}
    >
      {renderTestCompleteModalView()}
    </Modal>
  );

  const testErrorModal = () => (
    <Modal
      footer={null}
      visible={true}
      closable={false}
      maskClosable={false}
      className="ant-modal"
      onCancel={() => setTestErrorModal(!isTestErrorModal)}
    >
      {renderTestErrorModalView()}
    </Modal>
  );

  const renderTestErrorModalView = () => (
    <div className="modal_container">
      <div className="modal_content">
        <text>
          You are not able to validate your skill at the moment. Please try again in future
        </text>
      </div>

      <div
        className="test_question_btn_container"
        style={{
          justifyContent: "center",
          display: "flex",
          width: "100%",
        }}
        onClick={() => {
          // navigate(-1);
          navigate("/testCenter", { replace: true });

          setTestErrorModal(false);
        }}
      >
        <Button type="primary" htmlType="submit" style={{ width: "45%" }}>
          Finish
        </Button>
      </div>
    </div>
  );

  const renderTestCompleteModalView = () => (
    <div className="modal_container">
      <div className="modal_img_container">
        <img src={GreenTickModal} style={{ width: "80px", height: "80px" }} />
      </div>
      <div className="modal_content">
        <text>Thank you for taking the test, the results are now part of your profile rank.</text>
      </div>

      <div
        className="test_question_btn_container"
        style={{
          justifyContent: "center",
          display: "flex",
          width: "100%",
        }}
        onClick={() => {
          // navigate(-1);
          navigate("/testCenter", { replace: true });

          setTestCompletedModal(false);
        }}
      >
        <Button type="primary" htmlType="submit" style={{ width: "45%" }}>
          Finish
        </Button>
      </div>
    </div>
  );

  return !isEmpty(testQuestions) ? (
    <>
      <Webcam
        muted={false}
        disabled={true}
        audio={false}
        mirrored={true}
        height={200}
        ref={webcamRef}
        width={200}
        screenshotFormat="image/jpeg"
        videoConstraints={videoConstraints}
      />

      <div
        className="test_center__container disable-selection"
        style={{ backgroundColor: "rgba(223,223,223,45%)" }}
      >
        <div className="test_questions_card_header">
          <div className="flex_column">
            <text>Skill Test</text>
            <text>{testSkill}</text>
          </div>
          {countDownSec}
        </div>

        {!isEmpty(testQuestions) && questionSec}

        <div
          className="test_question_btn_container"
          onClick={() => {
            capture();
          }}
        >
          <Button
            type="primary"
            htmlType="submit"
            style={{ width: "20%", height: "50px" }}
            loading={isLoader}
            disabled={isLoader}
          >
            {!isLoader && testQuestionIndex < testQuestions.length - 1 ? "Next" : "Submit"}
          </Button>
        </div>
        {isTestCompletedModal && testCompleteModal()}
        {isTestErrorModal && testErrorModal()}
      </div>
      {!cameraPermission && (
        <Modal
          footer={null}
          visible={true}
          className="ant-modal"
          onCancel={(e) => {
            setCameraPermission(!cameraPermission);
          }}
        >
          <CameraPermissionDescription
            onCloseDescriptionModal={() => {
              setCameraPermission(!cameraPermission);
            }}
          />
        </Modal>
      )}
    </>
  ) : (
    <div
      style={{
        width: "70%",
        height: "100vh",
        display: "flex",
        flex: 1,
        alignItems: "center",

        justifyContent: "center",
        marginLeft: "250px",
        flexDirection: "column",
      }}
    >
      <SkeletonTheme baseColor={COLOR_CONSTANTS.shimmer_listing}>
        <div style={{ width: "100%", marginBottom: "20px" }}>
          <Skeleton count={3} height={"50"} />
        </div>

        <div style={{ width: "100%", marginBottom: "20px" }}>
          <Skeleton count={3} height={"50"} />
        </div>
        <div style={{ width: "100%", marginBottom: "20px" }}>
          <Skeleton count={3} height={"50"} />
        </div>
        <div style={{ width: "100%", marginBottom: "20px" }}>
          <Skeleton count={3} height={"50"} />
        </div>
        <div style={{ width: "100%", marginBottom: "20px" }}>
          <Skeleton count={3} height={"50"} />
        </div>
        <div style={{ width: "100%", marginBottom: "20px" }}>
          <Skeleton count={3} height={"50"} />
        </div>
      </SkeletonTheme>
    </div>
  );
}

export default TestQuestions;
